var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtractMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 666,
    viewBox: "0 0 343 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -38.4,
    y: -38.2652,
    width: 419.644,
    height: 741.7
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(19.2px)",
      clipPath: "url(#bgblur_0_6501_1332_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 38.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6501_1332",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.545 40.127C211.545 48.9635 218.708 56.127 227.545 56.127H326.844C335.68 56.127 342.844 63.2904 342.844 72.127V649.035C342.844 657.872 335.68 665.035 326.844 665.035H16C7.16344 665.035 0 657.872 0 649.035V16.1348C0 7.29822 7.16344 0.134766 16 0.134766H195.545C204.381 0.134766 211.545 7.29821 211.545 16.1348V40.127Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.545 40.127C211.545 48.9635 218.708 56.127 227.545 56.127H326.844C335.68 56.127 342.844 63.2904 342.844 72.127V649.035C342.844 657.872 335.68 665.035 326.844 665.035H16C7.16344 665.035 0 657.872 0 649.035V16.1348C0 7.29822 7.16344 0.134766 16 0.134766H195.545C204.381 0.134766 211.545 7.29821 211.545 16.1348V40.127Z",
    fill: "white",
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.545 56.127V57.127H326.844V56.127V55.127H227.545V56.127ZM342.844 72.127H341.844V649.035H342.844H343.844V72.127H342.844ZM326.844 665.035V664.035H16V665.035V666.035H326.844V665.035ZM0 649.035H1V16.1348H0H-1V649.035H0ZM16 0.134766V1.13477H195.545V0.134766V-0.865234H16V0.134766ZM211.545 16.1348H210.545V40.127H211.545H212.545V16.1348H211.545ZM195.545 0.134766V1.13477C203.829 1.13477 210.545 7.85049 210.545 16.1348H211.545H212.545C212.545 6.74592 204.934 -0.865234 195.545 -0.865234V0.134766ZM0 16.1348H1C1 7.8505 7.71573 1.13477 16 1.13477V0.134766V-0.865234C6.61116 -0.865234 -1 6.74593 -1 16.1348H0ZM16 665.035V664.035C7.71572 664.035 1 657.319 1 649.035H0H-1C-1 658.424 6.61115 666.035 16 666.035V665.035ZM342.844 649.035H341.844C341.844 657.319 335.128 664.035 326.844 664.035V665.035V666.035C336.233 666.035 343.844 658.424 343.844 649.035H342.844ZM326.844 56.127V57.127C335.128 57.127 341.844 63.8427 341.844 72.127H342.844H343.844C343.844 62.7381 336.233 55.127 326.844 55.127V56.127ZM227.545 56.127V55.127C219.261 55.127 212.545 48.4112 212.545 40.127H211.545H210.545C210.545 49.5158 218.156 57.127 227.545 57.127V56.127Z",
    fill: "#D9D9D9",
    mask: "url(#path-1-inside-1_6501_1332)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_6501_1332_clip_path",
    transform: "translate(38.4 38.2652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.545 40.127C211.545 48.9635 218.708 56.127 227.545 56.127H326.844C335.68 56.127 342.844 63.2904 342.844 72.127V649.035C342.844 657.872 335.68 665.035 326.844 665.035H16C7.16344 665.035 0 657.872 0 649.035V16.1348C0 7.29822 7.16344 0.134766 16 0.134766H195.545C204.381 0.134766 211.545 7.29821 211.545 16.1348V40.127Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractMb);
export default __webpack_public_path__ + "static/media/Subtract-mb.feef74cb4d9d3f22e1669b7fca880abd.svg";
export { ForwardRef as ReactComponent };